import {
  Breakpoints,
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
  getWidth,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing('xs')};
  padding-bottom: ${getSpacing('m')};
`;

export interface StyledBodyItemProps {
  width?: number;
  row?: boolean;
  alignRight?: boolean;
  lastItem?: boolean;
}

export const StyledListItemWrapper = styled.div<{ marginBottom?: string }>`
  border: 1px solid ${colors.gray3};
  border-radius: ${getBorderRadius('s')};
  ${(p) => p.marginBottom && `margin-bottom: ${p.marginBottom};`}
  @media (max-width: ${Breakpoints.Mobile}px) {
    border: 1px solid ${colors.gray3};
  }
`;

export const StyledBodyItem = styled.div<StyledBodyItemProps>`
  width: ${(p) => (p.width ? `${p.width}px` : 'auto')};
  flex-grow: ${(p) => (p.width ? 0 : 1)};
  flex-shrink: ${(p) => (p.width ? 0 : 1)};
  display: flex;
  flex-direction: ${(p) => (p.row ? 'row' : 'column')};
  align-items: ${(p) =>
    p.row ? 'center' : p.lastItem ? 'flex-end' : 'flex-start'};
  gap: ${(p) => (p.row ? getSpacing('xs') : 0)};
  justify-content: ${(p) => (p.lastItem ? 'flex-end' : 'flex-start')};
  @media (min-width: ${Breakpoints.Desktop}px) {
    flex-basis: ${(p) => (p.width ? `${p.width}px` : 'auto')};
    margin-left: ${(p) => (p.lastItem ? 'auto' : 0)};
  }
`;

export const StyledItemBodyContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${getSpacing('l')};
  @media (max-width: ${Breakpoints.Tablet}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${getSpacing('xs')};
  }
  @media (max-width: ${Breakpoints.Mobile}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${getSpacing('xs')};
    max-width: 70%;
  }
`;

export const StyledListItem = styled.div<{ isFocused?: boolean }>`
  padding: ${getSpacing('xs')} ${getSpacing('m')};
  @media (max-width: ${Breakpoints.Tablet}px) {
    display: flex;
    padding: ${getSpacing('xs')} ${getSpacing('xs')};
  }
  outline: ${(props) =>
    props.isFocused ? `2px solid ${colors.black}` : 'none'};
`;

export const StyledSearchInputWrapper = styled.div`
  max-width: ${getWidth('form')};
  flex: 1;
`;

export const StyledSearchForm = styled.form`
  display: flex;
  gap: ${getSpacing('s')};
  align-items: flex-end;
`;

export const StyledSearchButtonWrapper = styled.div`
  height: ${getHeight('m')};
`;

export const StyledHeader = styled.div<{ removeBottomMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing('m')};
  margin-bottom: ${(p) => (p.removeBottomMargin ? 0 : getSpacing('m'))};
`;
